module.exports = __webpack_public_path__ + "media/images/icons/twitterIcon-f12bed521e22bb199e90765c3dc82ec0.svg";